/**
 * Ojar Stripe Checkout Integration
 * Handles redirect to Stripe Checkout with cart data
 */

(function () {
    'use strict';
    const freeLabel = window.ojarStrings?.labels?.free || '';

    // Configuration
    const isDevelopment = () => {
        const hostname = window.location.hostname;
        return hostname === '127.0.0.1' || hostname === 'localhost' || hostname.includes('myshopify.com');
    };

    const getApiEndpoint = () => {
        const productionUrl = 'https://ojar-checkout-api-v2.vercel.app/api/create-checkout-session';

        if (isDevelopment()) {
            // Use CORS proxy for development to bypass CORS restrictions
            // This allows testing from localhost/127.0.0.1 without modifying backend
            const corsProxy = 'https://cors-anywhere.herokuapp.com/';
            console.log('[Checkout] Development mode detected, using CORS proxy');
            return corsProxy + productionUrl;
        }

        return productionUrl;
    };

    const CONFIG = {
        apiEndpoint: getApiEndpoint(),
    };

    /**
     * Initialize checkout integration
     */
    function init() {
        // Override checkout buttons
        interceptCheckoutButtons();
    }

    /**
     * Intercept all checkout button clicks
     */
    function interceptCheckoutButtons() {
        // Cart drawer checkout button
        const cartDrawerCheckout = document.getElementById('CartDrawer-Checkout');
        if (cartDrawerCheckout) {
            cartDrawerCheckout.addEventListener('click', handleCheckoutClick);
        }

        // Main cart page checkout button
        const cartPageCheckout = document.querySelector('button[name="checkout"]');
        if (cartPageCheckout) {
            cartPageCheckout.addEventListener('click', handleCheckoutClick);
        }

        // Also watch for dynamically added buttons
        document.addEventListener('click', (e) => {
            if (e.target.matches('[name="checkout"], #CartDrawer-Checkout, .cart__checkout-button')) {
                handleCheckoutClick(e);
            }
        });
    }

    /**
     * Handle checkout button click
     */
    async function handleCheckoutClick(e) {
        e.preventDefault();
        e.stopPropagation();

        const button = e.target.closest('button');
        if (!button) return;

        // Show loading state
        button.classList.add('loading');
        button.disabled = true;

        try {
            // Get cart data
            const cart = await getCart();

            if (!cart.items || cart.items.length === 0) {
                throw new Error('Cart is empty');
            }

            // Calculate TRUE USD value for tracking
            // We look up the exact USD price from OjarPriceData to avoid currency conversion issues

            // Calculate TRUE USD value for tracking

            const fireCheckoutPixel = async () => {
                let attempts = 0;
                // Wait for OjarPriceData to be available (max 3s)
                while (!window.OjarPriceData && attempts < 30) {
                    await new Promise(r => setTimeout(r, 100)); // Wait 100ms
                    attempts++;
                }

                // Helper to get decimal text value from raw integer based on currency
                const getDecimals = (curr) => {
                    if (['OMR', 'KWD', 'BHD'].includes(curr)) return 3;
                    return 2;
                };

                // Helper to calculate exchange rate (USD / Local) from any available product
                const getUsdRate = (localCurrency) => {
                    if (localCurrency === 'USD') return 1;
                    if (!window.OjarPriceData) return 1;

                    // Find any product to calculate rate
                    for (const key in window.OjarPriceData) {
                        const p = window.OjarPriceData[key];
                        if (p['USD'] && p[localCurrency]) {
                            return p['USD'] / p[localCurrency];
                        }
                    }
                    return 1; // Default fallback
                };

                let usdTotal = 0;
                const cartCurrency = cart.currency; // e.g. 'OMR'
                const decimals = getDecimals(cartCurrency);
                const divisor = Math.pow(10, decimals); // 1000 for OMR, 100 for USD

                // Calculate Rate: e.g. 234 USD / 89 OMR = 2.62
                const usdRate = getUsdRate(cartCurrency);

                cart.items.forEach(item => {
                    let itemUsdCents = 0;

                    // STRATEGY 1: Explicit Lookup (Most Accurate)
                    // Check handle (and underscore variant just in case)
                    let priceFound = false;
                    let handleToTry = [item.handle, item.handle.replace(/-/g, '_')];

                    for (const handle of handleToTry) {
                        if (window.OjarPriceData && window.OjarPriceData[handle] && window.OjarPriceData[handle]['USD']) {
                            const usdPrice = window.OjarPriceData[handle]['USD']; // e.g. 234.00
                            itemUsdCents = Math.round(usdPrice * 100 * item.quantity);
                            priceFound = true;
                            break;
                        }
                    }

                    // STRATEGY 2: Fallback Conversion (If handle missing in hardcoded list)
                    if (!priceFound) {
                        // 1. Get float amount in local currency (e.g. 89000 / 1000 = 89.00)
                        const rawPrice = (item.final_line_price || item.line_price || 0);
                        const localAmount = rawPrice / divisor;

                        // 2. Convert to USD
                        const usdAmount = localAmount * usdRate;

                        // 3. Convert to Cents
                        itemUsdCents = Math.round(usdAmount * 100);

                        console.warn(`[Checkout] OjarPriceData missing for ${item.handle}. Converted ${localAmount} ${cartCurrency} to ${usdAmount} USD using rate ${usdRate}`);
                    }

                    usdTotal += itemUsdCents;
                });

                const usdValue = usdTotal / 100;

                // Fire InitiateCheckout tracking events
                try {
                    // Always use USD for Meta Pixel tracking
                    const trackingCurrency = 'USD';
                    const contentIds = cart.items.map(item => String(item.variant_id));

                    console.log('[Checkout] nn InitiateCheckout data:', {
                        cartValue: usdValue,
                        currency: trackingCurrency,
                        numItems: cart.item_count,
                        contentIds: contentIds
                    });

                    // if (typeof fbq === 'function') {
                    //     // fbq('trackSingle', '851309100851305', 'InitiateCheckout', {
                    //     //     content_ids: contentIds,
                    //     //     content_type: 'product',
                    //     //     num_items: cart.item_count,
                    //     //     value: usdValue,
                    //     //     currency: trackingCurrency
                    //     // });
                    //     fbq('track', 'InitiateCheckout', {
                    //         content_ids: contentIds,
                    //         content_type: 'product',
                    //         num_items: cart.item_count,
                    //         value: usdValue,
                    //         currency: trackingCurrency
                    //     });
                    //     console.log('%c[Checkout] bb Meta Pixel InitiateCheckout fired with value: ' + usdValue + ' ' + trackingCurrency, 'background: #4267B2; color: white; padding: 2px 6px; border-radius: 3px;');
                    // }

                    if (typeof fbq === 'function') {
                        // Product value + estimated shipping
                        const ESTIMATED_SHIPPING = 50;  // Static shipping estimate
                        const totalValueWithShipping = usdValue + ESTIMATED_SHIPPING;
                        
                        fbq('track', 'InitiateCheckout', {
                            content_ids: contentIds,
                            content_type: 'product',
                            num_items: cart.item_count,
                            value: totalValueWithShipping,    // Product + $50 estimated shipping
                            currency: trackingCurrency
                        });
                        console.log('%c[Checkout] Meta Pixel InitiateCheckout fired with value: ' + totalValueWithShipping + ' ' + trackingCurrency + ' (Product: ' + usdValue + ' + Shipping: ' + ESTIMATED_SHIPPING + ')', 'background: #4267B2; color: white; padding: 2px 6px; border-radius: 3px;');
                    }

                    // Google Analytics / Google Ads - begin_checkout
                    if (typeof gtag === 'function') {
                        gtag('event', 'begin_checkout', {
                            currency: trackingCurrency,
                            value: usdValue,
                            items: cart.items.map(item => ({
                                item_id: String(item.variant_id),
                                item_name: item.product_title,
                                quantity: item.quantity,
                                price: (item.final_price || item.price) / 100
                            }))
                        });
                        console.log('[Checkout] Google Analytics begin_checkout fired');
                    }
                } catch (trackingError) {
                    console.warn('[Checkout] Tracking error:', trackingError);
                }
            };

            // Trigger the pixel firing (async, don't block auth check)
            fireCheckoutPixel();

// Get currency state from OjarCurrency system
            const currencyState = {
                currency: window.OjarCurrency?.getCurrentCurrency?.() || 'USD',
                country: window.OjarCurrency?.getCurrentCountry?.() || 'US',
            };

            // ---- SAFETY NET: fix USD fallback when geo-detection failed ----
            try {
                var COUNTRY_TO_CURRENCY = {
                    AE: 'AED', SA: 'SAR', KW: 'KWD', BH: 'BHD', OM: 'OMR', QA: 'QAR',
                    GB: 'GBP',
                    DE: 'EUR', FR: 'EUR', IT: 'EUR', ES: 'EUR', NL: 'EUR', BE: 'EUR',
                    AT: 'EUR', IE: 'EUR', PT: 'EUR', GR: 'EUR', FI: 'EUR', LU: 'EUR',
                    MT: 'EUR', CY: 'EUR', SK: 'EUR', SI: 'EUR', EE: 'EUR', LV: 'EUR', LT: 'EUR'
                };
                var SUPPORTED = ['USD','EUR','GBP','SAR','AED','QAR','OMR','KWD','BHD'];
                var ctry = currencyState.country;
                var curr = currencyState.currency;
                if (curr === 'USD' && ctry && ctry !== 'US' && ctry !== 'CA') {
                    var derived = COUNTRY_TO_CURRENCY[ctry];
                    if (derived && SUPPORTED.indexOf(derived) !== -1) {
                        console.warn('[Checkout] Currency mismatch. Country:', ctry, '-> correcting USD to', derived);
                        currencyState.currency = derived;
                    }
                }
            } catch (curErr) {
                console.warn('[Checkout] Currency safety-net skipped:', curErr);
            }
        // ---- END SAFETY NET ----

        // Build cart items for API - INCLUDE all items, FREE items get price=0

            const cartItems = [];
            for (const item of cart.items) {
                // Check if this is a FREE item
                let isFreeItem = false;

                // Method 1: Check if price is $0 (VEX Auto Add to Cart app sets price to 0)
                if (item.price === 0 || item.final_price === 0 || item.line_price === 0) {
                    isFreeItem = true;
                }

                // Method 2: Check DOM data attributes
                if (!isFreeItem) {
                    const cartItemEl = document.querySelector(`[data-key="${item.key}"]`);
                    isFreeItem = cartItemEl?.dataset?.tags?.includes('sample-product') ||
                        cartItemEl?.dataset?.tags?.includes('gwp-item') ||
                        cartItemEl?.dataset?.isSample === 'true' ||
                        cartItemEl?.classList?.contains('cart-item__sample');
                }

                // Method 3: Fetch product to check tags
                if (!isFreeItem) {
                    try {
                        const productResponse = await fetch(`/products/${item.handle}.js`);
                        const product = await productResponse.json();
                        if (product.tags && (product.tags.includes('sample-product') || product.tags.includes('gwp-item'))) {
                            isFreeItem = true;
                        }
                    } catch (e) {
                        console.warn('[Checkout] Could not fetch product:', item.handle);
                    }
                }

                
            // INCLUDE all items - FREE items get price=0 and (FREE) suffix
                if (isFreeItem) {
                    console.log('[Checkout] Including FREE item at $0:', item.product_title);
                    cartItems.push({
                        handle: item.handle,
                        variantId: item.variant_id,
                        title: item.product_title + (freeLabel ? ` (${freeLabel})` : ''),
                        quantity: item.quantity,
                        price: 0,
                        image: item.featured_image?.url || item.image,
                        properties: item.properties || {},
                    });
                } else {
                    // Detect Absolute Oils item (has 'absolute-oil' tag) for quantity discount
                    let isAbsolute = false;
                    try {
                        const prodRes = await fetch(`/products/${item.handle}.js`);
                        const prod = await prodRes.json();
                        if (prod && Array.isArray(prod.tags)) {
                            isAbsolute = prod.tags.some(t => String(t).toLowerCase() === 'absolute-oil');
                        }
                    } catch (e) {
                        console.warn('[Checkout] Absolute-oil tag check failed for', item.handle);
                    }

                    cartItems.push({
                        handle: item.handle,
                        variantId: item.variant_id,
                        title: item.product_title,
                        quantity: item.quantity,
                        price: getItemPrice(item, currencyState.currency),
                        image: item.featured_image?.url || item.image,
                        properties: item.properties || {},
                        isAbsolute: isAbsolute,
                    });
                }
            }

            console.log('[Checkout] Sending', cartItems.length, 'items to Stripe (free items at $0)');

            // Save cart for restoration
            if (window.OjarCurrency?.saveCartForRestoration) {
                window.OjarCurrency.saveCartForRestoration(cartItems);
            }

            // Save cart data to localStorage for Purchase tracking on thank-you page
            // IMPORTANT: Save USD prices from original Shopify cart, not localized prices
            try {
                const usdTotal = cart.items.reduce((sum, item) => {
                    return sum + (item.final_line_price || item.line_price || 0);
                }, 0); // Already in USD cents from Shopify

                localStorage.setItem('ojar_checkout_cart', JSON.stringify({
                    items: cart.items.map(item => ({
                        variantId: item.variant_id,
                        title: item.product_title,
                        quantity: item.quantity,
                        price: item.price || 0 // USD cents per unit from Shopify
                    })),
                    total: usdTotal, // USD cents
                    timestamp: Date.now()
                }));
                console.log('[Checkout] Cart saved to localStorage for Purchase tracking. USD total:', usdTotal / 100);
            } catch (e) {
                console.warn('[Checkout] Could not save cart to localStorage:', e);
            }

            // Debug logging
            console.log('[Checkout] Sending to API:', {
                itemCount: cartItems.length,
                currency: currencyState.currency,
                countryCode: currencyState.country,
                cartToken: cart.token
            });

            
        // Read the email captured in the cart drawer (for abandoned checkout recovery)
            let ojarCheckoutEmail = '';
            try {
                ojarCheckoutEmail = sessionStorage.getItem('ojar_checkout_email') || '';
            } catch (e) {
                console.warn('[Checkout] Could not read stored email');
            }

            // Create checkout session
            const response = await fetch(CONFIG.apiEndpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    cartItems,
                    currency: currencyState.currency,
                    countryCode: currencyState.country,
                    cartToken: cart.token,
                    customerEmail: ojarCheckoutEmail || undefined,
                }),
            });

            if (!response.ok) {
                const error = await response.json();
                throw new Error(error.message || 'Failed to create checkout');
            }

            const { checkoutUrl } = await response.json();

            // Redirect to Stripe Checkout
            // REMOVED: Duplicate InitiateCheckout - the correct one is fired in fireCheckoutPixel() earlier
            // trackInitiateCheckout(cartItems, currencyState);

            // Small delay to ensure pixels have a chance to fire
            setTimeout(() => {
                window.location.href = checkoutUrl;
            }, 500);

        } catch (error) {
            console.error('Checkout error:', error);
            const checkoutErrorMessage =
              window.ojarStrings?.checkout?.processingError ||
              window.cartStrings?.error;
            if (checkoutErrorMessage) {
                alert(checkoutErrorMessage);
            }

            // Reset button
            button.classList.remove('loading');
            button.disabled = false;
        }
    }

    /**
     * Track InitiateCheckout event
     */
    function trackInitiateCheckout(items, currencyState) {
        try {
            // Always use USD for Meta Pixel tracking (prices are in USD cents from Shopify)
            const currency = 'USD';
            const value = items.reduce((total, item) => total + (item.price * item.quantity), 0) / 100;

            console.log('[Checkout] trackInitiateCheckout data:', {
                value: value,
                currency: currency,
                numItems: items.reduce((acc, item) => acc + item.quantity, 0),
                contentIds: items.map(item => String(item.variantId))
            });

            // Meta Pixel (using trackSingle to send all data to our specific pixel)
            // Pixel ID: 851309100851305
            if (window.fbq) {
                window.fbq('trackSingle', '851309100851305', 'InitiateCheckout', {
                    value: value,
                    currency: currency,
                    content_ids: items.map(item => String(item.variantId)),
                    content_type: 'product',
                    num_items: items.reduce((acc, item) => acc + item.quantity, 0)
                });
                console.log('%c[Checkout] Meta Pixel InitiateCheckout (2nd) fired with value: ' + value + ' ' + currency, 'background: #4267B2; color: white; padding: 2px 6px; border-radius: 3px;');
            }

            // GA4 / GTM
            if (window.gtag) {
                window.gtag('event', 'begin_checkout', {
                    currency: currency,
                    value: value,
                    items: items.map(item => ({
                        item_id: String(item.variantId),
                        item_name: item.title,
                        price: item.price / 100,
                        quantity: item.quantity
                    }))
                });
            }

            // DataLayer push (for direct GTM tags)
            if (window.dataLayer) {
                window.dataLayer.push({
                    'event': 'begin_checkout',
                    'ecommerce': {
                        'currency': currency,
                        'value': value,
                        'items': items.map(item => ({
                            'item_id': String(item.variantId),
                            'item_name': item.title,
                            'price': item.price / 100,
                            'quantity': item.quantity
                        }))
                    }
                });
            }

        } catch (e) {
            console.warn('Tracking failed:', e);
        }
    }

    /**
     * Fetch current cart from Shopify
     */
    async function getCart() {
        const response = await fetch('/cart.js');
        return response.json();
    }

    /**
     * Get item price in selected currency (in cents/smallest unit)
     */
    function getItemPrice(item, currency) {
        // Check if we have custom price data
        if (window.OjarPriceData && window.OjarPriceData[item.handle]) {
            const price = window.OjarPriceData[item.handle][currency];
            if (price !== undefined) {
                // Convert to smallest unit
                return priceToSmallestUnit(price, currency);
            }
        }

        // Fallback to Shopify price (already in cents)
        return item.price;
    }

    /**
     * Convert price to smallest currency unit
     */
    function priceToSmallestUnit(price, currency) {
        const threeDecimalCurrencies = ['OMR', 'KWD', 'BHD'];
        const multiplier = threeDecimalCurrencies.includes(currency) ? 1000 : 100;
        return Math.round(price * multiplier);
    }

    // Expose for external use
    window.OjarCheckout = {
        init,
        redirectToStripe: handleCheckoutClick,
        setApiEndpoint: (url) => { CONFIG.apiEndpoint = url; },
    };

    // Initialize on DOM ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();